import { render, staticRenderFns } from "./boxCard.vue?vue&type=template&id=15b98d82&scoped=true"
import script from "./boxCard.vue?vue&type=script&lang=js"
export * from "./boxCard.vue?vue&type=script&lang=js"
import style0 from "./boxCard.vue?vue&type=style&index=0&id=15b98d82&lang=scss"
import style1 from "./boxCard.vue?vue&type=style&index=1&id=15b98d82&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b98d82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15b98d82')) {
      api.createRecord('15b98d82', component.options)
    } else {
      api.reload('15b98d82', component.options)
    }
    module.hot.accept("./boxCard.vue?vue&type=template&id=15b98d82&scoped=true", function () {
      api.rerender('15b98d82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/boxCard.vue"
export default component.exports